import React, { useEffect, useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { Context } from '../../context/UserContext';

const Index = () => {

    const context = useContext(Context);
    const { readData } = useEntityCrud('Branch/GetAllHoldings');
    const { addData: updateData } = useEntityCrud('Branch/ChangeStatus');
    const [rows, setRows] = useState([]);

    const getData = () => {
        readData().then(({ data }) => {
            if (data.status)
                setRows(data.result);
        });
    }

    useEffect(() => {
        getData();
    }, []);

    const deActiveRow = id => {
        const postedData = {
            id,
            status: false
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت هلدینگ مورد نظر با موفقیت به روزرسانی شد');
                getData();
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const activeRow = id => {
        const postedData = {
            id,
            status: true
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت هلدینگ مورد نظر با موفقیت به روزرسانی شد');
                getData();
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">هلدینگ ها</div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ایجاد هلدینگ</Link> : ''}
                {context.checkHasPermission('create') ? <hr /> : ''}
                {rows.length ? <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>  آدرس</th>
                             <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.title}</td>
                                <td>{item.address}</td>

{/*                                 <td>{item.isActive ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td>
 */}
                                <td className="btn-list">
                                    {context.checkHasPermission('update') ? <Link to={'update/' + item.id} className="btn btn-icon mb-0 btn-primary" title="ویرایش"><i className="fe fe-edit-2"></i></Link> : ''}
                                    {/*                                     
                                    {item.isActive ? <button onClick={e => deActiveRow(item.id)} className="btn btn-icon mb-0 btn-danger"><i className="fe fe-x"></i></button> : <button onClick={e => activeRow(item.id)} className="btn btn-icon mb-0 btn-success"><i className="fe fe-check"></i></button>}
                                    */}
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table> : <div className="alert alert-info"><p>هلدینگی یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;